module.exports = __webpack_public_path__ + "img/other.4c22890c.svg";